<template>
  <div class="h-auto bg-white w-full mt-5 pt-6 pb-5 pl-5 pr-5 rounded-14">
    <div>
      <listeDetailsHead />
    </div>
    <div class="all">
      <!-- Si showDetails est faux, on montre la liste -->
      <div v-if="!showDetails">
        <div
          v-for="(item, index) in items"
          :key="index"
          @click="selectItem(item)"
          class="w-full flex items-center text-c14 2xl:text-c16 font-c4 text-left mb-6 diviser px-3 rounded-t-14 cursor-pointer hover:bg-gray-100"
        >
          <!-- Nom de l'entreprise -->
          <div class="w-1/3 flex items-center gap-3 font-c5 text-c15 2xl:text-c20 text-black">
            <icon
              :data="icons.iconCompanyBlue"
              height="24"
              width="20"
              class="w-5 h-5"
              original
            />
            {{ item.name }}
          </div>
  
          <!-- Contact -->
          <div class="w-1/4 ml-4 text-titre flex items-center gap-3">
            <icon
              :data="icons.iconAbdelKader"
              height="32"
              width="32"
              class="w-5 h-5"
              original
            />
            {{ item.contact }}
          </div>
  
          <!-- Service -->
          <div class="w-1/5 ml-4">
            {{ item.value1 }}
          </div>
  
          <!-- Ville -->
          <div class="w-1/4 ml-4">
            {{ item.value2 }}
          </div>
  
          <!-- Nombre collaborateurs ou info extra -->
          <div class="w-1/4 ml-4">
            {{ item.email }}
          </div>
        </div>
      </div>
  
      <!-- Sinon on montre le composant de détails -->
      <div v-else>
        <detailsPartners :partner="selectedItem" />
      </div>
    </div>
  </div>
</template>
  
  
  <script>
  import user from '../../../assets/icons/ic-clientAv.svg'
  import entreprise from '../../../assets/icons/ic-entreprise.svg'
  import IconFececamBenin from '../../../assets/icons/ic-fececamBenin.svg'
  import detailsPartners from './deailsPartners.vue' // attention au nom du fichier icie
  import listeDetailsHead from './listeDetailsHead.vue'
  import iconCompanyBlue from '../../../assets/icons/ic_companyBlue.svg'
  import iconAbdelKader from '../../../assets/icons/ic_abdelKader.svg'
  
  export default {
    name: "Index",
    components: {
      detailsPartners,
      listeDetailsHead
    },
    data() {
      return {
        showDetails: false,
        selectedItem: null,
        icons: {
          user,
          entreprise,
          IconFececamBenin,
          iconCompanyBlue,
          iconAbdelKader
        },
        items: [
        {
            icon: 'IconFececamBenin',
            name: 'FECECAM Bénin',
            email: 'contact@fececam.bj',
            value1: '09',
            value2: '01',
            contact: 'Marcel Topkonsi',
          },          {
            icon: 'IconFececamBenin',
            name: 'FECECAM Bénin',
            email: 'contact@fececam.bj',
            value1: '09',
            value2: '01',
            contact: 'Marcel Topkonsi',
          },          {
            icon: 'IconFececamBenin',
            name: 'FECECAM Bénin',
            email: 'contact@fececam.bj',
            value1: '09',
            value2: '01',
            contact: 'Marcel Topkonsi',
          },          {
            icon: 'IconFececamBenin',
            name: 'FECECAM Bénin',
            email: 'contact@fececam.bj',
            value1: '09',
            value2: '01',
            contact: 'Marcel Topkonsi',
          },          {
            icon: 'IconFececamBenin',
            name: 'FECECAM Bénin',
            email: 'contact@fececam.bj',
            value1: '09',
            value2: '01',
            contact: 'Marcel Topkonsi',
          },
          // Tu peux rajouter d'autres partenaires ici
        ],
      };
    },
    methods: {
    selectItem(item) {
      this.$emit('partnerSelected', item); // ← on envoie l'item sélectionné
    }
  }
  ,
  };
  </script>
  
  <style lang="scss" scoped>
  .svg-icon {
    fill: transparent;
  }
  .item:hover {
    border-left: 3px groove black;
    padding-left: 30px;
  }
  </style>
  